import React from "react";
import { connect } from "react-redux";
import { Trans } from "react-i18next";

import ModalRoutes from "../../../ModalRoutes";
import Navbar from "../../../../Navbar";
import { VehicleWhite } from "../../../../Common/Buttons/Icons";

import { useVehicles } from "./hooks/useVehicles";
import { VehicleFilters } from "./VehicleFilters";
import { SearchBar } from "./SearchBar";
import { VehiclesList } from "./VehiclesList_DEPRECATED";
import { EmptyState } from "./EmptyState";

const LegacyVehicleOverview = (props) => {
  const {
    vehicles,
    searching,
    loading,
    addVehicle,
    vehiclesCountTotal,
    vehicleFiltersData,
    searchFilters,
    sortFilters,
    setSearchFilters,
    searchTerm,
    setSearchTerm,
    searchOnScroll,
    updateSorting,
    startExport,
  } = useVehicles(props);

  document.title = 'Vehicle Overview - FleetXPress'

  return (
    <div className="bkg-white-dark listviewnew">
      <Navbar history={props.history} match={props.match} location={props.location} />
      <div className="titlebar">
        <div className="titlebar-left">
          <div className="left">
            <h1><Trans>Vehicle Overview</Trans></h1>
          </div>
        </div>
        <div className="titlebar-right">
          <div className="right">
            <div className="desktop-action">
              <a className="button primary px-32" onClick={() => addVehicle()}>
                <span className="mr-8" style={{ verticalAlign: "sub" }}>{VehicleWhite()}</span>
                <Trans>Add Vehicle</Trans>
              </a>
            </div>
            <div className="mobile-action">
              <a className="button primary circle px-32" onClick={() => addVehicle()}>
                <span>{VehicleWhite()}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="list-container">
        <div className="list-wrapper">
          <VehicleFilters
            vehicles={vehicles}
            vehiclesCountTotal={vehiclesCountTotal}
            vehicleFiltersData={vehicleFiltersData}
            searchFilters={searchFilters}
            setSearchFilters={setSearchFilters}
          />

          <div className="mainsection">
            <SearchBar
              searching={searching}
              searchTerm={searchTerm}
              setSearchTerm={setSearchTerm}
            />

            <div className="table-section" onScroll={searchOnScroll}>
              {loading || vehicles?.length > 0 ? (
                <VehiclesList
                  vehicles={vehicles}
                  loading={loading}
                  sortBy={sortFilters.sortBy}
                  sortOrder={sortFilters.sortOrder}
                  updateSorting={updateSorting}
                  {...props}
                />
              ) : (
                <EmptyState />
              )}
            </div>
          </div>
        </div>
      </div>
      <ModalRoutes match={props.match} history={props.history} />
    </div>
  );
};

const mapStateToProps = (store) => ({
  userSession: store.userSession,
  data: store.data,
  settings: store.settings,
  stakeholder: store.stakeholder,
});

export default connect(mapStateToProps)(LegacyVehicleOverview);
